<template>
  <v-app>
    <v-container class="pa-0">
      <v-row class="ma-0">
        <v-col class="col-12">
          <v-row class="ma-0">
            <v-col
              class="col-12 col-md-8 px-0"
              :class="{'mb-4': $vuetify.breakpoint.smAndDown, 'mb-0': $vuetify.breakpoint.mdAndUp}"
            >
              <h2 class="pl-3">Pesquisar Profissionais</h2>
              <div class="block-search align-center justify-center d-flex">
                <v-row class="justify-center">
                  <v-col class="col-10 col-md-6 text-center">
                    <v-text-field
                      solo
                      hide-details
                      prepend-inner-icon="search"
                      label="Procure o nome do psicólogo."
                      class="input-search"
                      v-model="searchName"
                      @keyup.enter="searchPsychologists()"
                    ></v-text-field>
                    <v-btn
                      class="mt-2"
                      color="secondary"
                      large
                      @click="searchPsychologists()"
                    >PESQUISAR</v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-col>

            <v-col
              class="col-12 col-md-4"
              :class="{'mb-4': $vuetify.breakpoint.smAndDown, 'mb-0': $vuetify.breakpoint.mdAndUp}"
            >
              <h2>Próximas Consultas</h2>
              <v-row>
                <v-col
                  class="col-12 mt-4"
                  v-for="(item, index) in consultation"
                  :key="index"
                  :v-if="consultation.length != 0"
                >
                  <v-divider></v-divider>
                  <router-link
                    tag="div"
                    style="cursor: pointer;"
                    class="my-list"
                    :to="{name: 'DetalheConsultaPaciente', params: {id: item.id}}"
                  >
                    <p class="ma-0">{{item.psychologist.name}}</p>
                    <span class="date ma-2 align-end d-flex">
                      <v-icon color="primary">date_range</v-icon>
                      <p class="mb-0 ml-2">{{ item.date | formatDate }}</p>
                    </span>
                    <span class="time ma-2 align-end d-flex">
                      <v-icon color="primary">access_time</v-icon>
                      <p class="mb-0 ml-2">{{ item.time | formatDateTZ(item.date) }}</p>
                    </span>
                  </router-link>
                </v-col>
              </v-row>
              <v-row class="fill-height justify-center" v-if="!isConsultation && !isLoading">
                <v-col class="col-10">
                  <div class="no-schedule pa-3">
                    <v-icon
                      x-large
                      color="gray"
                      style="font-size: 80px; padding-bottom:10px"
                    >sentiment_very_dissatisfied</v-icon>
                    <p
                      class="subtitle-1"
                      style="color: #6F6F6F; font-weight: bold"
                    >Você não tem compromissos futuros.</p>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="col-12 py-3">
          <div>
            <h2 class="text-center">Profissionais em Destaque</h2>
            <v-container class="pa-0">
              <v-row>
                <v-col class="col-12 col-sm-6 col-md-3" v-for="user in users" :key="user.id">
                  <CardPsy :name="user.name" :img="user.photo" :id="user.id" />
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-footer class="pa-0">
      <v-row class="ma-0 justify-center">
        <v-col class="primary py-3 text-center white--text col-12" style="font-size: 12px">
          <strong>RESPONSÁVEL TÉCNICO</strong> Inês Mata CRP/03: 9904. OPP: CP 23204
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import http from '@/services/httpClient';
import moment from 'moment';
import HelloWorld from '../../components/HelloWorld';
import CardPsy from '../../components/CardPsy';

export default {
  components: {
    HelloWorld,
    CardPsy,
    moment,
  },

  data: () => ({
    cod: '',
    users: [],
    consultation: [],
    searchName: '',
    isConsultation: Boolean,
  }),

  async created() {
    await this.getPsiSpotlight();
    await this.getCod();
    await this.allConsultation();
  },

  methods: {
    getCod() {
      this.cod = localStorage.getItem('user-id');
    },
    getPsiSpotlight() {
      http
        .get('/psychologists/?is_featured=true', {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        })
        .then((response) => {
          // console.log(response.data.results);
          this.users = response.data.results;
        });
    },
    async allConsultation() {
      // this.isLoading = true;
      const date = moment().format('YYYY-MM-DD HH:mm');
      try {
        const { data, status } = await http.get(
          `/patients/${this.cod}/appointments/`,
          {
            params: {
              after_date_time: date,
              limit: '4',
            },
            headers: {
              Authorization: `Token ${localStorage.getItem('user-token')}`,
            },
          },
        );
        if (status == 200) {
          if (data.length != 0) {
            this.consultation = data;
            this.isConsultation = true;
          } else {
            this.isConsultation = false;
          }
        }

        // if (data.results.length != 0) {
        //   for (let index = 0; index < 5; index++) {
        //     this.consultation.push(data.results[index]);
        //   }
        //   // this.isConsultation = true;
        // }
      } catch (error) {
        console.log(error.response.data.detail);
      } finally {
        // this.isLoading = false;
      }
    },
    async searchPsychologists() {
      this.$router.push({
        name: 'BuscaPaciente',
        params: { name: this.searchName },
      });
    },
  },
};
</script>

<style lang="css" scoped>
h2 {
  color: var(--v-primary-base);
}

.block-search {
  background-image: url("../../assets/bg_dashboard.png");
  min-height: 360px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

* >>> .input-search.v-text-field--solo > .v-input__control > .v-input__slot {
  border-radius: 12px;
}

.my-list {
  display: flex;
  flex-direction: row;
  align-items: center;
}

p {
  flex: 1;
}

.no-schedule {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background: #02a55333;
  border-radius: 20px;
  border: 1px dashed #02a554;
}

/* funcionad de MD para baixo */
@media (max-width: 768px) {
  .block-search {
    background-size: cover;
  }
  .flex-md-row-reverse {
    -ms-flex-direction: row-reverse !important;
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    -ms-flex-direction: column-reverse !important;
    flex-direction: column-reverse !important;
  }
}
</style>
